(function () {
  const loadMore = document.getElementById('load-more');

  if (!loadMore) return;

  let paged = '1';
  const maxPages = loadMore.getAttribute('data-max-pages');
  const postType = loadMore.getAttribute('data-post-type');
  const category = loadMore.getAttribute('data-category') ?? '';
  const author = loadMore.getAttribute('data-author') ?? '';

  loadMore.addEventListener('click', function (event) {
    event.preventDefault();

    fetch(load_more_data.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        nonce: load_more_data.nonce,
        locale: load_more_data.locale,
        paged: paged,
        postType: postType,
        category: category,
        author: author,
        action: 'more_posts'
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.text();
      })
      .then(response => {
        paged++;
        const container = document.getElementById('article-list-archive');
        if (!container) return;

        container.insertAdjacentHTML('beforeend', response);

        paged == maxPages
          ? loadMore.remove()
          : loadMore.disabled = false;
      })
      .catch(error => {
        console.error('Error:', error);
        loadMore.disabled = false;
      });

    loadMore.disabled = true;
  });
})();